import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const CartPage = withCompass(() => import("../../pages/CartPage"));
const LjPdpPage = withCompass(() => import("../../pages/LjPdpPage"));

export function LeighJenningsRoutes() {
  return (
    <Switch>
      <Route path="/lj/lj-pdp" component={LjPdpPage} />
      <Route path="/lj/lj-pdp/cart" component={CartPage} />
    </Switch>
  );
}

export const slug = "lj";
